import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Navigate } from 'react-router-dom';
import PrivacyPolicy from './privacyPolicy';
import TermsOfService from './termsOfService';
import LegalNotice from './legalNotice';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/terms-of-use" />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/privacy-policy/:lang" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfService />} />
        <Route path="/terms-of-use/:lang" element={<TermsOfService />} />
        <Route path="/selfevaluation/legal-notice" element={<LegalNotice />} />
        <Route path="/selfevaluation/legal-notice/:lang" element={<LegalNotice />} />
      </Routes>
    </Router>
  );
}

export default App;
